export const floorFitness = '1. Patro';
export const floorOther = 'Přízemí';
export const textFitness =
  '- Posilovna, Solárium, Nehtové studio, Boxerský a Aerobní sál';
export const phoneFitness = '+420 775 563 301';
export const textOther =
  '- Sauny, Masáže, Lezecké stěny, MF Sál - Bungee, H.E.A.T., Tabata, Pilates, Jóga';
export const phoneOther = '+420 602 654 379';
